import * as Tone from 'tone';
import { isCapacitorNative } from 'Utils/Constants';
import logger from 'Utils/Logger';
import { resumeAudioClockIfStopped } from 'Utils/interruptionPause';

/**
 * MUS-505: call from a play control's own event handler, before the play state
 * changes, so the audio clock is asked to run inside the user gesture. Native
 * builds do not time playback off this clock.
 */
export function resumeAudioClockOnPlay(): void {
  if (isCapacitorNative()) return;
  resumeAudioClockIfStopped({
    state: () => (Tone.getContext().rawContext as AudioContext).state,
    // Tone.start() resumes Tone's context, and calls into it before returning.
    resume: () => Tone.start(),
    onError: (e) => logger.debug('[MUS-505] audio-clock resume failed', e),
  });
}
